import { Colors } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

export const serviceName = 'sendings'

export const sendingsStatuses = {
  pending: {
    icon: icons.update,
    color: Colors.info
  },
  paused: {
    icon: icons.pause_circle_outline,
    color: Colors.info
  },
  processing: {
    icon: icons.autorenew,
    color: Colors.info
  },
  sent: {
    icon: icons.trending_flat,
    color: Colors.info
  },
  delivered: {
    icon: icons.done,
    color: Colors.success
  },
  seen: {
    icon: icons.done_all,
    color: Colors.success
  },
  failed: {
    icon: icons.clear,
    color: Colors.error
  },
  moderation: {
    icon: icons.motion_photos_paused,
    color: Colors.warning
  }
}

export const getTabs = (data, hasPermissions) => {
  const result = [ 'format' ]
  if (hasPermissions) {
    result.push('source')

    const billings = data?.meta?.billings || data?.meta?.billing?.id
    const provider = data?.meta?._routing?.provider
    const contentHistory = data?.meta?.contentHistory
    const fallbacks = data?.fallbacks
    if (billings) {
      result.push('billings')
    }
    if (Array.isArray(fallbacks) && fallbacks.length) {
      result.push('fallbacks')
    }
    result.push('routing')
    if (provider) {
      result.push('logs')
    }
    if (contentHistory && contentHistory.length > 1) {
      result.push('replacement')
    }
  }

  return result
}
